import { ReactElement } from 'react';

import { Town } from '@dreryk/address-common-api';

import { BindingCreator, ValidationRules } from '@dreryk/react-common';
import { TownInput } from '@dreryk/react-components';

const TOWN_MAX_LENGTH = 50;

type TownFormBeanPart = {
   town: Town | null;
};

const validationRules: ValidationRules<TownFormBeanPart> = {
   maxLength: TOWN_MAX_LENGTH,
};

type TownFieldProps = {
   readonly register: BindingCreator<TownFormBeanPart, 'town'>;
};

export const TownField = (props: TownFieldProps): ReactElement => {
   return <TownInput testId={'town'} controller={props.register('town', validationRules)} defaultValue={null} />;
};
